// src/db/userDB.ts

import Dexie, { Table } from 'dexie';

// Define individual interfaces for each table
export interface AppTokenTable {
  id?: number;
  token?: string;
}


export interface UserInfoTable {
  id?: number;
  user?: {
    UserId?: number;
    Name?: string;
    Username?: string;
    Email?: string | null;
    // add other fields as needed
  };
}

export interface GradeMaster {
  Gradeid?: number;
  CompanyId?: number;
  GradeName?: string;
}

export interface Designations {
  DesignationId?: number;
  Designation?: string;
  DesignationColor?: string | null;
  CompanyId?: number;
  CreatedAt?: string;
  UpdatedAt?: string | null;
}

export interface OrgUnit {
  Orgunitid?: number;
  CompanyId?: number;
  UnitName?: string;
  OrgUnitCode?: string;
  CurrencyId?: number;
  CountryId?: number;
  CanDoCustomPlaylist?: boolean;
  IsExposed?: boolean;
  CreatedAt?: string;
  UpdatedAt?: string;
  OrgunitAdminPosition?: number;
  OnBoardRequiredFileds?: string | null;
  PunchinOnWeekoff?: boolean;
  PunchinOnHoliday?: boolean;
  PunchinOnLeave?: boolean;
  OutletType?: string | null;
  DefaultOutletType?: string;
  PrimaryOutletType?: string | null;
  SecondaryOutletType?: string | null;
  OtherOutletType?: string | null;
  CampaignEnable?: boolean;
}

export interface Branch {
  BranchId?: number;
  CompanyId?: number;
  Branchcode?: string;
  Branchname?: string;
  Status?: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  Istateid?: number | null;
}

export interface EmployeeData {
  EmployeeId?: number;
  CompanyId?: number;
  PositionId?: number;
  ReportingTo?: number;
  DesignationId?: number;
  BranchId?: number;
  GradeId?: number;
  OrgUnitId?: number;
  EmployeeCode?: string;
  FirstName?: string;
  LastName?: string;
  Status?: number;
  IpAddress?: string | null;
  ProfilePicture?: string | null;
  Email?: string;
  LastLogin?: string | null;
  Phone?: string | null;
  Address?: string | null;
  Costnumber?: string | null;
  CreatedAt?: string;
  UpdatedAt?: string;
  BaseMtarget?: string | null;
  IntegrationId?: string | null;
  Itownid?: string | null;
  Islocked?: boolean;
  Lockedreason?: string;
  Lockeddate?: string;
  Iseodcheckenabled?: number;
  EmployeeMedia?: string | null;
  ResiAddress?: string | null;
  CanFullSync?: boolean;
  Remark?: string | null;
  EmployeeSpokenLanguage?: string;
  LastUpdatedByUserId?: number | null;
  GradeMaster?: GradeMaster;
  Designations?: Designations;
  OrgUnit?: OrgUnit;
  Branch?: Branch;
}

export interface EmployeeTable {
  id?: number;
  employeeList?: EmployeeData[];
}

export interface ScopeTable {
  id?: number;
  scopes?: string[];
}

export interface TopLevelTable {
  id?: number;
  isTopLevel?: boolean;
}

// Create Dexie DB class
class UserDatabase extends Dexie {
  appToken!: Table<AppTokenTable, number>;
  userInfo!: Table<UserInfoTable, number>;
  employee!: Table<EmployeeTable, number>;
  scope!: Table<ScopeTable, number>;
  topLevel!: Table<TopLevelTable, number>;

  constructor() {
    super('UserDatabase');
    this.version(1).stores({
      appToken: '++id',
      userInfo: '++id, user.UserId',
      employee: '++id',
      scope: '++id',
      topLevel: '++id',
    });
  }
}

export const db = new UserDatabase();
